import AssetsTableHeaderTooltipContents from "components/assets-table-header/tooltip-contents"
import { assetDollarFormatter, makeCustomFormatter } from "helpers/formatters/numbers"
import { FORMATS } from "helpers/formatters/numbers"

const numberFormatter = makeCustomFormatter(FORMATS.NUMBER_FORMAT, { emptyValueFiller: "-" })

export function getNMVTooltipComponent(gmv, referenceEquity) {
  if (!gmv && !referenceEquity) {
    return null
  }

  const tooltipContents = [
    {
      label: "GMV",
      value: assetDollarFormatter(gmv),
    },
  ]

  if (referenceEquity) {
    tooltipContents.push({
      label: "Reference Equity",
      value: assetDollarFormatter(referenceEquity),
    })
  }

  return <AssetsTableHeaderTooltipContents contents={tooltipContents} />
}

export function getLeverageTooltipComponent(leverageAmount) {
  const tooltipContents = [{
    label: "Composition % Equity",
    value: "Each asset's share of total equity, including modeled & unmodeled positions.",
  }]

  if (leverageAmount) {
    tooltipContents.push({
      label: "Leverage",
      value: assetDollarFormatter(leverageAmount),
    })
  }

  return <AssetsTableHeaderTooltipContents contents={tooltipContents} />
}

export function formatValueOrDash(value) {
  return value ? numberFormatter(value) : "--"
}

export function getResidualTooltipContents(residual) {
  return `Total return includes a residual adjustment of ${residual}`
}
